'use client';

import { useEffect } from 'react';

declare global {
  interface Window {
    _hmt: unknown[];
  }
}

/**
 * 百度统计组件
 * 在客户端加载百度统计代码，用于跟踪网站访问数据
 */
const BaiduAnalytics = () => {
  useEffect(() => {
    // 只在生产环境加载百度统计
    if (typeof window !== 'undefined') {
      // 初始化 _hmt 数组（如果还不存在）
      window._hmt = window._hmt || [];
      
      // 检查是否已经存在百度统计脚本，避免重复加载
      const existingScript = document.querySelector('script[src*="hm.baidu.com"]');
      if (!existingScript) {
        console.log('正在加载百度统计脚本...');
        
        // 创建并插入百度统计脚本
        const script = document.createElement('script');
        script.src = 'https://hm.baidu.com/hm.js?fd62cb31b929e873ea4c3ba2f06bb58e';
        script.async = true;
        
        // 添加加载成功和失败的事件监听
        script.onload = () => {
          console.log('百度统计脚本加载成功');
          console.log('_hmt 对象状态:', window._hmt);
          // 发送一个测试事件
          if (window._hmt && Array.isArray(window._hmt)) {
            window._hmt.push(['_trackPageview']);
            console.log('已发送页面浏览统计');
          }
        };
        
        script.onerror = (error) => {
          console.warn('百度统计脚本加载失败 (这在开发环境中很常见):', error);
          // 静默处理，在生产环境中用户不会看到这些错误
        };
        
        // 找到第一个 script 标签并在其前插入
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          // 如果没有找到 script 标签，则直接添加到 head
          document.head.appendChild(script);
        }
      } else {
        console.log('百度统计脚本已存在，跳过加载');
      }
    }
  }, []);

  // 该组件不渲染任何可见内容
  return null;
};

export default BaiduAnalytics;